import './styles.scss';
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import { Fade } from 'react-awesome-reveal';
import { SkeletonBlogItem } from '../../components/comment/SkeletonBlogItem';
import { removeBaseUrl } from '../../utils';

const AttorneyBio = () => {
    const { slug } = useParams();
    const [isFetching, setIsFetching] = useState(true);
    const [pageContent, setPageContent] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = "Wood Hammel LLP";
        fetchPostContent(slug);
        return (() => {})
    }, [slug]);

    const fetchPostContent = async (slug) => {
        setIsFetching(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&slug=${slug}&page_name=attorney_bio`);
            setPageContent(data?.page ?? null);
            if (data?.page) {
                if (data?.page?.yoast_title?.length > 0) {
                    document.title = data?.page?.yoast_title;
                } else {
                    document.title = data?.page?.page?.post_title;
                }
            }

            const postId = data?.page?.page?.ID;
            if (document.querySelector('#wp-admin-bar-edit a') && postId) {
                document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${postId}&action=edit`;
            }

        } catch (err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    }

    const generateRandomWidth = () => {
        return `${Math.floor(Math.random() * 51) + 50}%`;
    };
    
    return <Fade delay={1}>
        <div className='attorney-bio-page'>
            <section id="banner" className='single-bio-banner'>
                <div className='inner-wrapper'>
                    <div className='banner-area'>
                        <span className='tag'>
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="5" cy="5" r="5" fill="#037C8E"/>
                            </svg>
                            Attorneys
                        </span>
                        {!isFetching && <h1>{pageContent?.banner?.title}</h1>}
                        {isFetching && <h1>{<Skeleton width={generateRandomWidth()} />}</h1>}
                        {!isFetching && <p>{pageContent?.banner?.banner_description}</p>}
                        {isFetching && <p>
                            {Array.from({length: 3}).map(it => <Skeleton width={generateRandomWidth()} key={it} />)}
                        </p>}
                    </div>
                </div>
            </section>

            <section id="attorney-details-container">
                <div className='attorney-sidebar-wrapper'>
                    {!isFetching && <div className='main-content' dangerouslySetInnerHTML={{__html: pageContent?.page?.post_content}}></div>}
                    {isFetching && <div className='main-content'>
                        {Array.from({length: 36}).map(it => <Skeleton width={generateRandomWidth()} key={it} height="20px" style={{marginTop: "6px"}} />)}
                    </div>}
                    <aside className={`sidebar ${pageContent?.attorney_meta?.attorney_profile_image ? 'has-featured-image' : ''}`}>
                        <div className='attorney-featured-image'>
                            {!isFetching && <img src={pageContent?.attorney_meta?.attorney_profile_image} />}
                            {isFetching && <Skeleton width="100%" height={"350px"} />}
                        </div>
                        <div className='meta-details-wrapper'>
                            <div className='contact-info'>
                                <div className='contact-item'>
                                    <label>Location: </label>
                                    {!isFetching && <span>{pageContent?.attorney_meta?.block_location}</span>}
                                    {isFetching && <span><Skeleton width="100px" /></span>}
                                </div>
                                <div className='contact-item'>
                                    <label>Phone: </label>
                                    {!isFetching && <a href={`tel:+1${pageContent?.attorney_meta?.block_phone}`}>{pageContent?.attorney_meta?.block_phone}</a>}
                                    {isFetching && <a href="#"><Skeleton width="120px" /></a>}
                                </div>
                                <div className='contact-item'>
                                    <label>Email: </label>
                                    {!isFetching && <a href={`mailto:${pageContent?.attorney_meta?.block_email}`}>{pageContent?.attorney_meta?.block_email}</a>}
                                    {isFetching && <span><Skeleton width="160px" /></span>}
                                </div>
                            </div>
                            {!isFetching && <div className='meta-content' dangerouslySetInnerHTML={{ __html: pageContent?.attorney_meta?.block_meta_content }}></div>}
                            {isFetching && <div className='meta-content'>
                                {
                                    Array.from({length: 10}).map(it => <Skeleton width={generateRandomWidth()} key={it} height="20px" style={{marginTop: "6px"}} />)
                                }
                            </div>}
                        </div>
                    </aside>
                </div>
            </section>

            <section id="posted-articles-section">
                <div className='inner-wrapper'>
                    <div id="section-header">
                        {!isFetching && <h2>{pageContent?.posted_articles?.section_title}</h2>}
                        {isFetching && <h2><Skeleton width="240px" height="32px" /></h2>}
                        <Link to={"/articles/"} className='button'>Browse All Articles</Link>
                    </div>

                    <div className="posts-wrapper">
                        <div className='posts-repeater'>
                            {
                                !isFetching && pageContent?.posted_articles?.articles?.map((it, index) => {
                                    return <div className='blog-item' key={index}>
                                        <Link to={removeBaseUrl(it?.permalink)} className='blog-title'>
                                            {it?.title}
                                        </Link>
                                        <div className='blog-meta'>
                                            <span className='author'>By {it?.author_name}</span>
                                            <span className='category'>
                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="5" cy="5" r="5" fill="#024953"/>
                                                </svg>
                                                {it?.category?.name}
                                            </span>
                                        </div>
                                        <span className='excerpt'>
                                            {it?.excerpt?.length > 100 ? `${it?.excerpt?.substring(0, 100)}...` : it.excerpt} <Link to={removeBaseUrl(it?.permalink)}>Read more</Link>
                                        </span>
                                    </div>
                                })
                            }
                            {
                                isFetching && Array.from({length: 3}).map(it => <SkeletonBlogItem key={it} />)
                            }
                        </div>
                    </div>

                </div>
            </section>
        </div>
    </Fade>
}

export default AttorneyBio;